import React from "react";
import styles from "./ElchemyExpertise.module.scss";
import Image from "next/image";
import { useRouter } from "next/router";
import { getCDNImageUrl } from "@/utils/Common";

const cardData = [
  {
    id: 1,
    number: "01",
    heading: "Customized formulations",
    description:
      "We specialize in crafting personalized chemical formulations, precisely tailored to meet your specific needs. Our team of skilled chemists and engineers collaborate closely with you to ensure the perfect alignment of properties and performance characteristics in our formulations",
  },
  {
    id: 2,
    number: "02",
    heading: "Quality assurance",
    description:
      "Our foundation is built on quality, showcasing our unwavering dedication to the highest standards and safety. Rigorous quality control and cutting-edge testing facilities guarantee that each batch not only meets but surpasses industry and regulatory benchmarks, solidifying our reputation.",
  },
  {
    id: 3,
    number: "03",
    heading: "Process expertise",
    description:
      "Our skilled team offers extensive technical knowledge and experience. Refined processes ensure efficiency, yield, and quality optimization. From scaling production to resolving challenges, our experts guarantee a seamless, efficient, and cost-effective chemical manufacturing experience.",
  },
  {
    id: 4,
    number: "04",
    heading: "Cost competitiveness",
    description:
      "Our advanced technology-driven processes and supply chain management allow us to find cost efficiencies without compromising quality. With Elchemy, you get the best of both worlds – custom-tailored solutions at competitive prices.",
  },
];

const Card = ({ card }) => {
  return (
    <div className={styles.card}>
      {/* Number */}
      <div className={styles.number}>{card.number}</div>
      {/* Heading */}
      <div className={styles.heading}>{card.heading}</div>
      {/*Description */}
      <div className={styles.description}>{card.description}</div>
    </div>
  );
};

function ElchemyExpertise() {
  const router = useRouter();

  const onClickLearnMore = () => {
    router.push("/quality-custom-chemical-manufacturing");
  };

  return (
    <div className={styles.elchemyExpertise}>
      {/* Small Heading */}
      <h6>ELCHEMY EXPERTISE</h6>
      {/* Big Heading */}
      <h2>Custom Manufacturing</h2>
      {/* Description */}
      <p>
        Elchemy makes custom manufacturing simple, scalable, and reliable.
        Whether you need support with development (CDMO), research (CRO), or
        production (CMO), our network of audited sites and technical experts
        helps you bring high-quality products to market faster
      </p>
      <div className={styles.cardsAndImageSection}>
        {/* Cards */}
        <div className={styles.cardsSection}>
          {cardData.map((card) => (
            <Card key={card.id} card={card} />
          ))}
        </div>
        {/* Image Section */}
        <div className={styles.imageSection}>
          {/* Image Wrapper for sticky positioning */}
          <div className={styles.imageWrapper}>
            {/* Image Container */}
            <div className={styles.imageContainer}>
              <Image
                src={getCDNImageUrl("elchemy-expertise.webp")}
                alt="Elchemy Expertise"
                fill
                className={styles.image}
              />
            </div>
            {/* Button */}
            <div onClick={onClickLearnMore} className={styles.buttonContainer}>
              <button>Learn More</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ElchemyExpertise;
